import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bt-dash" }
const _hoisted_2 = { class: "row p-0" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = {
  class: "custom-scrollbar",
  style: {"height":"35dvh","overflow-y":"auto"}
}
const _hoisted_5 = { class: "w-100 table table-fixed" }
const _hoisted_6 = { class: "bg-white" }
const _hoisted_7 = { class: "align-middle" }
const _hoisted_8 = { class: "align-middle" }
const _hoisted_9 = { class: "align-middle" }
const _hoisted_10 = { class: "align-middle" }
const _hoisted_11 = { class: "align-middle" }
const _hoisted_12 = { class: "align-middle" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "f-w-700" }
const _hoisted_15 = { class: "f-w-700" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "col-12 mt-3"
}
const _hoisted_18 = { class: "box-list-container bg-white rounded p-3 card" }
const _hoisted_19 = { style: {"grid-column":"span 6 / span 6"} }
const _hoisted_20 = { style: {"grid-column":"span 3 / span 3"} }
const _hoisted_21 = { style: {"grid-column":"span 3 / span 3"} }
const _hoisted_22 = { style: {"grid-column":"span 6 / span 6"} }
const _hoisted_23 = { class: "d-flex align-items-center gap-2 form-check checkbox-checked" }
const _hoisted_24 = {
  for: `checkbox-allow-reduction`,
  style: {"margin-top":"12px"}
}
const _hoisted_25 = { style: {"grid-column":"span 3 / span 3"} }
const _hoisted_26 = {
  class: "btn btn-primary px-2",
  type: "button",
  style: {"width":"100%"},
  "data-bs-toggle": "modal",
  "data-original-title": "test",
  "data-bs-target": "#product-search-modal"
}
const _hoisted_27 = { style: {"grid-column":"span 3 / span 3"} }

import { ref, computed, onMounted, reactive, watch, defineAsyncComponent } from 'vue';
import { useProductsStore } from '@/store/management/productsStore';
import type { LinkGroups, Product, SetItems } from '@/store/management/productsStore';
import { addSetItemAPI } from '@/utils/api';
import { viviposToSetitem, setItemToVivipos } from '@/store/management/productsStore';
import Swal from 'sweetalert2';

import { useI18n } from 'vue-i18n'
import { productsLanguage } from '@/core/locales/products-language'


export default /*@__PURE__*/_defineComponent({
  __name: 'productSetItems',
  setup(__props) {

const { t } = useI18n({
  messages: productsLanguage
})

const productAddSetItemModal = defineAsyncComponent(() => import('./productAddSetItemModal.vue'));
const productGroupSearchModal = defineAsyncComponent(() => import('./productGroupSearchModal.vue'));
const productSearchModal = defineAsyncComponent(() => import('./productSearchModal.vue'));

const productStore = useProductsStore();

const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

const compState = reactive({
    setItems: [] as SetItems[],
    activeSelectedItem: {} as SetItems
})

const onAddSetItem = (setItems: SetItems) => {
    compState.setItems.push(setItems);
    compState.activeSelectedItem = setItems;
};

const onRemoveSetItem = (index: number) => {
    compState.setItems.splice(index, 1);
    compState.activeSelectedItem = {} as SetItems;
}

const onSetItemClick = (item: SetItems) => {
    compState.activeSelectedItem = item;
}

const onSelectedProduct = (product: Product) => {
    compState.activeSelectedItem.presetItem = product;
    // if (activeProduct.value.basic.productNumber === product.basic.productNumber) {
    //     Swal.fire({
    //         icon: 'error',
    //         title: 'Oops...',
    //         text: 'Cannot select the same product as preset item',
    //     });
    //     return;
    // } else {
    //     compState.activeSelectedItem.presetItem = product;
    // }

}

const onSelectedGroup = (group: LinkGroups) => {
    compState.activeSelectedItem.linkGroup = group;

}

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        const productGroup = tempActiveProduct.value
        const setItemsData = productGroup.setItems
        compState.setItems = setItemsData
    }
})

watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        const setItemsData = productGroup.setItems
        compState.setItems = setItemsData
    }
}, { immediate: true });

watch(compState, (newVal) => {
    console.log('newVal',newVal);

    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        setItems: newVal.setItems
    })
}, { deep: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _createElementVNode("thead", _hoisted_6, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_7, _toDisplayString(_unref(t)('Label')), 1),
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_unref(t)('Preset Item')), 1),
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_unref(t)('Qty')), 1),
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_unref(t)('Price')), 1),
                  _createElementVNode("th", _hoisted_11, _toDisplayString(_unref(t)('Group')), 1),
                  _createElementVNode("th", _hoisted_12, _toDisplayString(_unref(t)('Allow Reduction')), 1),
                  _createElementVNode("th", null, [
                    _createElementVNode("button", {
                      class: "btn btn-primary px-2",
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = () => {}),
                      "data-bs-toggle": "modal",
                      "data-original-title": "test",
                      "data-bs-target": "#product-add-set-modal",
                      style: {"width":"128px"}
                    }, _toDisplayString(_unref(t)('Add Set Item')), 1)
                  ])
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(compState.setItems, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id,
                    class: _normalizeClass(["hover-shadow hover-pointer", { active: compState.activeSelectedItem.id === item.id }]),
                    onClick: ($event: any) => (onSetItemClick(item))
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.label), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(item.presetItem?.basic?.name || 'N/A'), 1),
                    _createElementVNode("td", null, _toDisplayString(item.quantity), 1),
                    _createElementVNode("td", null, _toDisplayString(item.basePrice), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(item.linkGroup?.name || 'N/A'), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("i", {
                        class: _normalizeClass(item.allowReduction ? 'fa fa-check' : 'fa fa-times')
                      }, null, 2)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "btn btn-danger px-2",
                        type: "button",
                        onClick: _withModifiers(($event: any) => (onRemoveSetItem(index)), ["stop"]),
                        style: {"width":"128px"}
                      }, [
                        _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fa fa-times" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_unref(t)('Remove')), 1)
                      ], 8, _hoisted_16)
                    ])
                  ], 10, _hoisted_13))
                }), 128))
              ])
            ])
          ])
        ]),
        (compState?.activeSelectedItem?.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", null, _toDisplayString(_unref(t)('Label')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compState.activeSelectedItem.label) = $event))
                  }, null, 512), [
                    [_vModelText, compState.activeSelectedItem.label]
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", null, _toDisplayString(_unref(t)('Base Price')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((compState.activeSelectedItem.basePrice) = $event))
                  }, null, 512), [
                    [_vModelText, compState.activeSelectedItem.basePrice]
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", null, _toDisplayString(_unref(t)('Qty')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((compState.activeSelectedItem.quantity) = $event))
                  }, null, 512), [
                    [_vModelText, compState.activeSelectedItem.quantity]
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: `checkbox-allow-reduction`,
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((compState.activeSelectedItem.allowReduction) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, compState.activeSelectedItem.allowReduction]
                    ]),
                    _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(t)('Allow Reduction')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("button", _hoisted_26, _toDisplayString(_unref(t)('Preset Item')), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("button", {
                    class: "btn btn-secondary px-2",
                    type: "button",
                    onClick: _cache[5] || (_cache[5] = () => {}),
                    style: {"width":"100%"},
                    "data-bs-toggle": "modal",
                    "data-original-title": "test",
                    "data-bs-target": "#product-group-search-modal"
                  }, _toDisplayString(_unref(t)('Product Group')), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_unref(productAddSetItemModal), { onOnSave: onAddSetItem }),
    _createVNode(_unref(productSearchModal), { onOnSelect: onSelectedProduct }),
    _createVNode(_unref(productGroupSearchModal), { onOnSelect: onSelectedGroup })
  ], 64))
}
}

})